var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.story)?_c('StoryblokComponent',{attrs:{"blok":_vm.story.content}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }